/* eslint-disable import/prefer-default-export */
export const ClientContactPhoneTypeList = [
  { value: 'CALL_ONLY', label: 'Appel uniquement' },
  { value: 'WHATSAPP_ONLY', label: 'Whatsapp uniquement' },
  { value: 'CALL_AND_WHATSAPP', label: 'Whatsapp/Appel' },
];
